export default __webpack_public_path__ + "static/2.5.4/media/europeanUnion.af98b549.svg";